import { createTheme } from "@mui/material/styles";
import { colors } from "@mui/material";

export const themeModes = {
  dark: "dark",
  light: "light",
};

const themeConfigs = {
  custom: ({ mode }) => {
    const customPalette =
      mode === themeModes.dark
        ? {
            primary: {
              main: "#FF8C00",
              contrastText: "#ffffff",
            },
            secondary: {
              main: "#FFA500",
              contrastText: "#ffffff",
            },
            background: {
              default: "#000000",
              paper: "#0a0a0a",
            },
          }
        : {
            primary: {
              main: "#FF8C00",
            },
            secondary: {
              main: "#FFA500",
            },
            background: {
              default: colors.grey["100"],
            },
          };

    return createTheme({
      palette: {
        mode,
        ...customPalette,
      },
    });
  },
};
export default themeConfigs;
